import { EDITOR_CONSTANTS } from "@perceptron/constants/editorConstants";
import type { Schema, Slice } from "@tiptap/pm/model";
import { getText, getTextSerializersFromSchema } from "@tiptap/react";

/**
 * The prompt as plain text on the clipboard: its text blocks, a blank line apart. ProseMirror's default puts
 * a block separator around every block, so a media container, which has no text, came out as an empty gap
 * (two newlines) wherever an image sat. Text blocks keep the editor's own serializers for inline nodes.
 */
export function promptClipboardText(slice: Slice, schema: Schema): string {
  const textSerializers = getTextSerializersFromSchema(schema);
  const blocks: string[] = [];
  slice.content.forEach((node) => {
    if (node.type.name === EDITOR_CONSTANTS.NODE_TYPES.MEDIA_SET_CONTAINER) return;
    blocks.push(getText(node, { blockSeparator: "\n\n", textSerializers }));
  });
  return blocks.join("\n\n");
}
